module.exports = __webpack_public_path__ + "img/upload.ec89d41a.svg";